module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-4"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('em', [_vm._v("Analysis")])])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('p', {
    staticClass: "list2"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('span', {
    staticClass: "pad"
  })]), _c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec2-1"
    }
  }, [_c('strong', [_vm._v("I. Introduction, 1:1-15")])])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec3-1"
    }
  }, [_vm._v("A. Salutation, 1:1-7")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec3-2"
    }
  }, [_vm._v("B. Prayer, 1:8-15")])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "pad1"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec2-2"
    }
  }, [_c('strong', [_vm._v("II. Thesis, 1:16-17")])])])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec2-3"
    }
  }, [_c('strong', [_vm._v("III. The Way of Deliverance, 1:18–5:21")])])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec3-3"
    }
  }, [_vm._v("A. Universal Sinfulness, 1:18–3:20")])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec4-1"
    }
  }, [_c('em', [_vm._v("1. The Condemnation of the Gentile World, 1:18-32")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec4-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. The Condemnation of the Jew, 2:1-16")])])]), _vm._v(" "), _c('p', {
    staticClass: "list5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. The danger of judging others, 2:1-3")])]), _vm._v(" "), _c('p', {
    staticClass: "list5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec5-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. The need for repentance, 2:4")])]), _vm._v(" "), _c('p', {
    staticClass: "list5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec5-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Judgment, 2:5-16")])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec4-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. "), _c('em', [_vm._v("The Jew, 2:17–3:8")])])]), _vm._v(" "), _c('p', {
    staticClass: "list5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec5-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. The Jew’s confidence, 2:17-20")])]), _vm._v(" "), _c('p', {
    staticClass: "list5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec5-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. The Jew’s failure, 2:21-24")])]), _vm._v(" "), _c('p', {
    staticClass: "list5"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec5-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. The inward and the outward, 2:25-29")])]), _vm._v(" "), _c('p', {
    staticClass: "list5"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#sec5-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d. The faithfulness of God, 3:1-4")])]), _vm._v(" "), _c('p', {
    staticClass: "list5"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#sec5-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("e. Objections, 3:5-8")])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#sec4-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. Universal Sinfulness—Proof from Scripture, 3:9-20")])])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#sec3-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Justification, 3:21–5:21")])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#sec4-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. How Justification Is Effected, 3:21-31")])])]), _vm._v(" "), _c('p', {
    staticClass: "list5"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#sec5-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. The death of Christ, 3:21-26")])]), _vm._v(" "), _c('p', {
    staticClass: "list5"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#sec5-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Faith, 3:27-31")])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#sec4-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. "), _c('em', [_vm._v("Justification Proved from Abraham, 4:1-25")])])]), _vm._v(" "), _c('p', {
    staticClass: "list5"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#sec5-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. God’s way is grace, 4:1-8")])]), _vm._v(" "), _c('p', {
    staticClass: "list5"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#sec5-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Faith and circumcision, 4:9-12")])]), _vm._v(" "), _c('p', {
    staticClass: "list5"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#sec5-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Faith and law, 4:13-17")])]), _vm._v(" "), _c('p', {
    staticClass: "list5"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#sec5-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d. Faith and Abraham, 4:18-25")])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec4-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. "), _c('em', [_vm._v("The Effects of Justification, 5:1-11")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#sec4-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. Solidarity in Adam and in Christ, 5:12-21")])])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06#sec2-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("IV. The Way of Godliness, 6:1–8:39")])])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06#sec3-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Shall We Continue to Sin That Grace May Abound? 6:1-14")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06#sec3-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Shall We Sin Because We Are under Grace, Not Law? 6:15–7:6")])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06#sec4-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. We Are Not Slaves, 6:15-23")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec4-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. An Illustration from Marriage, 7:1-6")])])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec3-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. Is the Law Sin? 7:7-12")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec3-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. Did the Good Law Cause Death? 7:13-25")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter08#sec3-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E. The Holy Spirit in the Believer, 8:1-39")])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('span', {
    attrs: {
      "href": "#/018_Chapter08#sec4-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. The Opposition of Flesh and Spirit, 8:1-11")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter08#sec4-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. The Family of God, 8:12-17")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter08#sec4-13",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. The Glorious Future, 8:18-25")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter08#sec4-14",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. The Spirit’s Intercession, 8:26-27")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter08#sec4-15",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("5. The Purpose of God, 8:28-30")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter08#sec4-16",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("6. The Christian’s Triumph Song, 8:31-39")])])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    staticClass: "pad1"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#sec2-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("V. The Place of Israel, 9:1–11:36")])])])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#sec3-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. The Tragedy of Israel, 9:1-5")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#sec3-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. God’s Sovereign Freedom, 9:6-29")])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#sec4-17",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. God Works by Election, 9:6-13")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#sec4-18",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. God’s Purpose Is Mercy, 9:14-18")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#sec4-19",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. God’s Wrath and God’s Mercy, 9:19-29")])])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#sec3-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. Human Responsibility, 9:30–10:21")])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter09#sec4-20",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. The “Stumbling Stone”, 9:30-33")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#sec4-21",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. Two Ways of Righteousness, 10:1-13")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter10#sec4-22",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. Worldwide Proclamation, 10:14-21")])])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter11#sec3-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. God’s Promises Will Be Fulfilled, 11:1-36")])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter11#sec4-23",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. The Remnant of Israel, 11:1-10")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter11#sec4-24",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. The Restoration of Israel, 11:11-24")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter11#sec4-25",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. The Conversion of Israel, 11:25-32")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter11#sec4-26",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. The Mercy of God, 11:33-36")])])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter12#sec2-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("VI. Christian Living, 12:1–15:13")])])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter12#sec3-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. The Christian Attitude to God, 12:1-2")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter12#sec3-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. The Christian Attitude to Other Christians, 12:3-16")])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter12#sec4-27",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. Humility, 12:3")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter12#sec4-28",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. Difference of Function, 12:4-8")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter12#sec4-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. "), _c('em', [_vm._v("Love of the Brothers, 12:9-10")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter12#sec4-30",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4. Some Practical Advice, 12:11-16")])])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter12#sec3-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. The Christian Attitude to Non-Christians, 12:17-21")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter13#sec3-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. The Christian Attitude to Civil Rulers, 13:1-7")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter13#sec3-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E. The Christian Attitude to People in General, 13:8-10")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter13#sec3-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F. Living in the Light, 13:11-14")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter14#sec3-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G. Love and Liberty, 14:1–15:13")])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter14#sec4-31",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. Christian Liberty, 14:1-12")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter14#sec4-32",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. The Way of Peace and Love, 14:13-23")])])]), _vm._v(" "), _c('p', {
    staticClass: "list4"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter15#sec4-33",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. Christian Unity, 15:1-13")])])]), _vm._v(" "), _c('p', {
    staticClass: "list2"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter15#sec2-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("VII. Conclusion, 15:14–16:27")])])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter15#sec3-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. The Minister of the Gentiles, 15:14-22")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter15#sec3-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Paul’s Plans, 15:23-33")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter16#sec3-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. Commendation of Phoebe, 16:1-2")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter16#sec3-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. Greetings, 16:3-16")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter16#sec3-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E. A Doctrinal Warning, 16:17-20")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter16#sec3-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F. Greetings from People with Paul, 16:21-24")])]), _vm._v(" "), _c('p', {
    staticClass: "list3"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter16#sec3-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G. Doxology, 16:25-27")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92dd187e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/010_Analysis.vue
// module id = 84
// module chunks = 0